import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

import I18n from "../i18n.js";

import Button from "../buttons/button.js";

const blockStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.grayText,
    padding: "0px",
    fontSize: "14px",
    backgroundColor: "transparent",
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: "transparent",
      textDecoration: "underline",
      boxShadow: "none !important",
    },
    display: "flex",
    justifyContent: "flex-start"
  },
  label: {
    color: theme.palette.grayText,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "auto"
  },
  text: {
    display: "block",
    marginTop: "2px",
    marginLeft: "4px"
  },
  icon: {
    width: "0.75em",
    height: "0.75em"
  }
}));

const BackButton = (props) => {
  const classes = blockStyles();

  const { className, history } = props;

  const onBack = () => {
    history.goBack();
  }

  return (
    <React.Fragment>
      {
        history.length > 1 &&
        <Button className = { clsx(classes.root, className) }
                labelClass = { classes.label }
                onClick = { onBack } >
          <ChevronLeftIcon className = { classes.icon }/>
          <div className = { classes.text } >
            { I18n.t("action.back") }
          </div>
        </Button>
      }
    </React.Fragment>
  );
}

export default compose(withRouter)(BackButton);
